import Item from "./Item";

export default function FaqItem() {
  return (
    <Item
      link={"https://sesc.nsu.ru/olymp-vsesib/faq/"}
      label={"Частые вопросы"}
      isExternal={true}
    />
  );
}
